/**
 * name to namespace the stuff we add to the window object
 */
export const WINDOW_NAMESPACE = "myLibrary";
export const windowNamespaceObject = (childObjectName, childObject) => {
    let ns = (window[WINDOW_NAMESPACE] = window[WINDOW_NAMESPACE] || {});
    if (childObjectName && childObject) {
        ns = ns[childObject] = ns[childObject] || childObject;
    }
    else if (childObjectName) {
        ns = ns[childObject] = ns[childObject] || {};
    }
    return ns;
};
export const hasNamespaceObject = (childObjectName) => {
    return window[WINDOW_NAMESPACE] && window[WINDOW_NAMESPACE][childObjectName];
};
/**
 * namespace used inside data attributes, to define plugins or its parameters
 *
 * examples for plugin definitions:
 * data-<DATA_ATTR_NAMESPACE>-plugins="p1,p2"
 * or with an empty namespace: data-plugins="p1,p2"
 *
 * examples for plugin parameter:
 * data-<DATA_ATTR_NAMESPACE>-<PLUGIN_NAME>-<PARAMETER_NAME>="some value"
 * or with an empty namespace: data-<PLUGIN_NAME>-<PARAMETER_NAME>="some value"
 */
export const DATA_ATTR_NAMESPACE = "";
//# sourceMappingURL=index.js.map